import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect, createContext } from "react";
import "@/App.css";

// Pages
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import CarDetail from "@/pages/CarDetail";
import Finance from "@/pages/Finance";
import Insurance from "@/pages/Insurance";
import Inspector from "@/pages/Inspector";
import LifeCover from "@/pages/LifeCover";
import Admin from "@/pages/Admin";
import FAQ from "@/pages/FAQ";
import Advice from "@/pages/Advice";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import EVCharging from "@/pages/EVCharging";
import Dealers from "@/pages/Dealers";
import DealerPortal from "@/pages/DealerPortal";
import DealerBenefits from "@/pages/DealerBenefits";
import News from "@/pages/News";
import HelpMeFind from "@/pages/HelpMeFind";
import SellYourCar from "@/pages/SellYourCar";
import Affordability from "@/pages/Affordability";
import Specials from "@/pages/Specials";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookiePopup from "@/components/CookiePopup";

// Analytics
import { trackPageView } from "@/utils/analytics";

// Dark Mode Context
export const ThemeContext = createContext();

// Analytics tracker component
const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  
  return null;
};

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <div className={`App min-h-screen flex flex-col ${darkMode ? 'dark' : ''}`}>
        <BrowserRouter>
          <AnalyticsTracker />
          <Navbar />
          <main className="flex-1 bg-gray-50 dark:bg-gray-900 transition-colors">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* SEO landing pages */}
              <Route path="/cars" element={<Results />} />
              <Route path="/cars/:make" element={<Results />} />
              <Route path="/cars/:make/:model" element={<Results />} />
              <Route path="/cars/under/:maxPrice" element={<Results />} />
              <Route path="/cars/in/:province" element={<Results />} />  
              <Route path="/results" element={<Results />} />
              <Route path="/car/:id" element={<CarDetail />} />
              <Route path="/car-detail" element={<CarDetail />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/insurance" element={<Insurance />} />
              <Route path="/inspector" element={<Inspector />} />
              <Route path="/life-cover" element={<LifeCover />} />
              <Route path="/ev-charging" element={<EVCharging />} />
              <Route path="/dealers" element={<Dealers />} />
              <Route path="/dealer-portal" element={<DealerPortal />} />
              <Route path="/dealer-benefits" element={<DealerBenefits />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<News />} />
              <Route path="/help-me-find" element={<HelpMeFind />} />
              <Route path="/sell-your-car" element={<SellYourCar />} />
              <Route path="/affordability" element={<Affordability />} />
              <Route path="/specials" element={<Specials />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/advice" element={<Advice />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
          <CookiePopup />
        </BrowserRouter>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
